import event from './event'
import market from './market'

export default {
  event,
  market
}



// WEBPACK FOOTER //
// ./src/library/betting/index.js